// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"86ec13c8","196":"0b983d6a","662":"767f7f3d","692":"0b983d6a","843":"9d8621ff","877":"fe11d5e5","887":"d4988b0d","972":"d4988b0d"}[chunkId] + ".chunk.css";
};